export default __webpack_public_path__ + "static/media/hachef.914a011e.png";